import React from "react";
import { Link, useLocation } from "react-router-dom";

const Finance = () => {
  const location = useLocation();


  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname === to;

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}

        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {renderNavItem("/finance/sales", "Sales Invoice", "flaticon-interface-9")}

      {renderNavItem(
        "/finance/payment-received",
        "Payment Received",
        "flaticon-price-tag "
      )}
    </>
  );
};

export default Finance;
